import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AccountType } from '@shared/enums';
import { UserDetailsFacade } from '@shared/state/facades';
import { combineLatest, map, Observable } from 'rxjs';
import {
  canMatchAccountGuard,
  canMatchAppStatusGuard,
  canMatchClientGuard,
} from '.';
import { CanActivateFn, CanMatchFn } from '@shared/models/guard';

export const canActivateSystemAdminGuard: CanActivateFn =
  (): Observable<boolean> => {
    const router = inject(Router);
    const userDetailsFacade = inject(UserDetailsFacade);

    return combineLatest([
      canMatchAccountGuard(),
      canMatchClientGuard(),
      canMatchAppStatusGuard(),
      userDetailsFacade.query.accountType$,
    ]).pipe(
      map(([hasAccount, hasClient, isAppOnline, accountType]) =>
        hasPermissions(router, hasAccount, hasClient, isAppOnline, accountType)
      )
    );
  };

export const canMatchSystemAdminGuard: CanMatchFn = (): Observable<boolean> => {
  const router = inject(Router);
  const userDetailsFacade = inject(UserDetailsFacade);

  return combineLatest([
    canMatchAccountGuard(),
    canMatchClientGuard(),
    canMatchAppStatusGuard(),
    userDetailsFacade.query.accountType$,
  ]).pipe(
    map(([hasAccount, hasClient, isAppOnline, accountType]) =>
      hasPermissions(router, hasAccount, hasClient, isAppOnline, accountType)
    )
  );
};

const hasPermissions = (
  router: Router,
  hasAccount: boolean,
  hasClient: boolean,
  isAppOnline: boolean,
  accountType: AccountType
): boolean => {
  if (
    !hasAccount ||
    !hasClient ||
    !isAppOnline ||
    accountType !== AccountType.SystemAdmin
  ) {
    router.navigate(['/']);

    return false;
  }

  return true;
};
